/* ============================================================
   YESUGOD Shoppable — behaviour layer
   ============================================================ */
(function () {
  if (customElements.get('yg-shoppable')) return;
  var isTouch = window.matchMedia('(hover: none)').matches;
  function inLightbox(el){ return !!(el && el.closest && el.closest('.yg-lightbox')); }
  function track(name, data) {
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') { window.Shopify.analytics.publish(name, data || {}); } } catch (e) {}
  }
  function cardData(card) {
    if (!card) return {};
    var d = card.dataset || {};
    return { product_id: d.ygProductId||null, product_handle: d.ygProductHandle||null, product_title: d.ygProductTitle||null, heading: d.ygHeading||null, media_type: d.ygMedia||null };
  }
  class YGShoppable extends HTMLElement {
    connectedCallback() {
      this.cfg = { autoplay: this.dataset.autoplay==='true', hover: this.dataset.hover==='true', tap: this.dataset.tap==='true', loop: this.dataset.loop==='true', muted: this.dataset.muted!=='false' };
      this.sectionId = this.dataset.sectionId || null;
      this.track = this.querySelector('.yg-shoppable__track');
      this.videos = Array.prototype.slice.call(this.querySelectorAll('video[data-yg-video]'));
      this.initVideos(); this.initImpressions(); this.initControls(); this.initClicks(); this.initNav(); this.initLoadMore();
    }
    initImpressions() {
      var self=this; var cards=Array.prototype.slice.call(this.querySelectorAll('.yg-card'));
      if(!('IntersectionObserver' in window)) return;
      var io=new IntersectionObserver(function(entries){ entries.forEach(function(e){ if(e.isIntersecting){ var c=e.target; if(!c.dataset.ygSeen){ c.dataset.ygSeen='1'; track('yesugod_shoppable_view', Object.assign({section_id:self.sectionId}, cardData(c))); } io.unobserve(c); } }); }, {threshold:0.5});
      cards.forEach(function(c){ io.observe(c); });
    }
    initVideos() {
      var self=this;
      var io=new IntersectionObserver(function(entries){ entries.forEach(function(e){ var v=e.target; if(e.isIntersecting){ self.hydrate(v); if(self.cfg.autoplay) self.play(v); } else { if(!inLightbox(v)) self.pause(v); } }); }, {threshold:0.4});
      this.videos.forEach(function(v){
        v.muted=self.cfg.muted; v.loop=self.cfg.loop; v.playsInline=true; v.setAttribute('playsinline','');
        if(self.cfg.autoplay){ self.hydrate(v); }
        io.observe(v);
        if(self.cfg.hover && !self.cfg.autoplay && !isTouch){ var card=v.closest('.yg-card'); card.addEventListener('mouseenter', function(){ self.hydrate(v); self.play(v); }); card.addEventListener('mouseleave', function(){ if(inLightbox(v)) return; self.pause(v); }); }
      });
    }
    hydrate(v){ if(v.dataset.hydrated) return; var src=v.getAttribute('data-src'); if(src){ var s=document.createElement('source'); s.src=src; s.type=v.getAttribute('data-type')||'video/mp4'; v.appendChild(s); v.load(); } v.dataset.hydrated='1'; v.addEventListener('loadeddata', function(){ v.classList.add('is-ready'); }, {once:true}); if(v.readyState>=2){ v.classList.add('is-ready'); } }
    play(v){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); this.syncBtn(v,true); if(!v.dataset.ygPlayed){ v.dataset.ygPlayed='1'; track('yesugod_shoppable_play', Object.assign({section_id:this.sectionId}, cardData(v.closest('.yg-card')))); } }
    pause(v){ v.pause(); this.syncBtn(v,false); }
    syncBtn(v,playing){ var btn=v.closest('.yg-card').querySelector('.yg-card__playpause'); if(btn){ btn.setAttribute('aria-pressed', String(playing)); btn.dataset.playing=playing?'1':'0'; } }
    initControls(){
      var self=this;
      this.querySelectorAll('.yg-card__playpause').forEach(function(btn){ btn.addEventListener('click', function(e){ e.stopPropagation(); var v=btn.closest('.yg-card').querySelector('video'); if(!v) return; self.hydrate(v); v.paused?self.play(v):self.pause(v); }); });
      this.querySelectorAll('.yg-card__mute').forEach(function(btn){ var v=btn.closest('.yg-card').querySelector('video'); if(!v) return; btn.classList.toggle('is-unmuted', !v.muted); btn.addEventListener('click', function(e){ e.stopPropagation(); v.muted=!v.muted; btn.classList.toggle('is-unmuted', !v.muted); btn.setAttribute('aria-pressed', String(v.muted)); if(!v.muted){ self.hydrate(v); if(v.paused) self.play(v); } }); });
    }
    initHotspots(){} closeHotspots(){}
    initClicks(){ var self=this; this.addEventListener('click', function(ev){ var shop=ev.target.closest('[data-yg-shop]'); if(!shop) return; track('yesugod_shoppable_click', {section_id:self.sectionId, product_handle:shop.getAttribute('data-yg-shop'), via: shop.closest('.yg-hotspot__preview')?'hotspot':'product_card'}); }); }
    initNav(){
      var prev=this.querySelector('[data-yg-prev]'); var next=this.querySelector('[data-yg-next]');
      var trk=this.track; if(!trk || (!prev && !next)) return;
      var vp = trk.closest('.yg-shoppable__viewport') || trk.parentNode;
      function step(){
        var card = trk.querySelector('.yg-card:not([hidden])');
        var cw = card ? card.getBoundingClientRect().width : trk.clientWidth*0.85;
        var gs = getComputedStyle(trk);
        var gap = parseFloat(gs.columnGap) || parseFloat(gs.gap) || 0;
        var unit = cw + gap;
        var per = Math.max(1, Math.floor(trk.clientWidth / unit));
        return per * unit;
      }
      function update(){
        var max = trk.scrollWidth - trk.clientWidth;
        if(vp) vp.classList.toggle('yg-has-overflow', max > 4);
        if(prev) prev.disabled = trk.scrollLeft <= 2;
        if(next) next.disabled = trk.scrollLeft >= (max - 2);
      }
      function go(dir){
        var max = trk.scrollWidth - trk.clientWidth;
        var startL = trk.scrollLeft;
        var target = Math.max(0, Math.min(startL + dir*step(), max));
        if (Math.abs(target - startL) < 1) return;
        trk.style.scrollSnapType = 'none';
        try { trk.scrollTo({ left: target, behavior: 'smooth' }); } catch(e){ trk.scrollLeft = target; }
        setTimeout(function(){ if (Math.abs(trk.scrollLeft - startL) < 2) trk.scrollLeft = target; }, 90);
        clearTimeout(trk.__ygSnap);
        trk.__ygSnap = setTimeout(function(){ trk.style.scrollSnapType = ''; update(); }, 700);
      }
      if(prev) prev.addEventListener('click', function(){ go(-1); });
      if(next) next.addEventListener('click', function(){ go(1); });
      trk.addEventListener('scroll', function(){ update(); }, {passive:true});
      window.addEventListener('resize', update);
      update(); setTimeout(update, 200);
    }
    initLoadMore(){ var btn=this.querySelector('[data-yg-more]'); if(!btn) return; var self=this; btn.addEventListener('click', function(){ self.querySelectorAll('.yg-card[hidden]').forEach(function(c,i){ if(i<6)c.hidden=false; }); if(!self.querySelector('.yg-card[hidden]')) btn.hidden=true; }); }
  }
  customElements.define('yg-shoppable', YGShoppable);
})();

/* ===================== editorial refinement: dock hotspots + drag + lightbox(body) + ajax cart ===================== */
(function(){
  function rootUrl(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/'; }
  function ygCartCount(n){ document.querySelectorAll('[data-js-cart-count]').forEach(function(el){ el.textContent = n; }); }
  function ygToast(msg){
    var t = document.getElementById('yg-toast');
    if(!t){ t = document.createElement('div'); t.id='yg-toast'; t.className='yg-toast'; document.body.appendChild(t); }
    t.innerHTML = '<span>'+(msg||'Added to bag')+'</span><a href="'+rootUrl()+'cart">View bag</a>';
    requestAnimationFrame(function(){ t.classList.add('is-visible'); });
    clearTimeout(t._t);
    t._t = setTimeout(function(){ t.classList.remove('is-visible'); }, 4000);
  }

  document.querySelectorAll('.yg-shoppable').forEach(function(root){
    if (root.classList.contains('yg-lightbox')) return;
    var isTouch = window.matchMedia('(hover:none)').matches;
    var lb = null;
    var closeLightbox = function(){};

    function setDots(card){
      var hs = card.querySelector('.yg-card__hotspots'); if(!hs) return;
      var isVideo = !!card.querySelector('video');
      var active  = card.classList.contains('yg-is-active');
      var on;
      if (isVideo){ on = card.classList.contains('yg-is-playing') || active; }
      else        { on = active || card.__hover || isTouch; }
      card.setAttribute('data-yg-dots', on ? 'on' : 'off');
    }
    function owns(card){ return card && ((card.closest('.yg-shoppable') === root) || (lb && lb.contains(card))); }
    function scopeFor(card){ return (lb && lb.contains(card)) ? lb : root; }

    root.querySelectorAll('.yg-card').forEach(function(card){
      card.__hover = false;
      card.addEventListener('mouseenter', function(){ card.__hover = true;  setDots(card); });
      card.addEventListener('mouseleave', function(){ card.__hover = false; setDots(card); });
      var vid = card.querySelector('video');
      if (vid){
        card.classList.add('yg-card--has-video');
        var on  = function(){ card.classList.add('yg-is-playing');    setDots(card); };
        var off = function(){ card.classList.remove('yg-is-playing'); setDots(card); };
        vid.addEventListener('play', on); vid.addEventListener('playing', on);
        vid.addEventListener('pause', off); vid.addEventListener('ended', off);
      }
      setDots(card);
    });

    function onHotspot(e){
      var dot = e.target.closest('.yg-hotspot__dot, .yg-hotspot'); if(!dot) return;
      var hotspot = dot.closest('.yg-hotspot'); var card = hotspot.closest('.yg-card');
      if(!owns(card)) return;
      var scope = scopeFor(card);
      var hs = hotspot.getAttribute('data-hs') || '0';
      var preview = card.querySelector('.yg-hotspot__preview[data-hs="'+hs+'"]') || card.querySelector('.yg-hotspot__preview');
      var wasActive = preview && preview.classList.contains('is-active');
      scope.querySelectorAll('.yg-hotspot__preview.is-active').forEach(function(p){ p.classList.remove('is-active'); });
      scope.querySelectorAll('.yg-hotspot.yg-is-active').forEach(function(h){ h.classList.remove('yg-is-active'); });
      scope.querySelectorAll('.yg-card.yg-is-active').forEach(function(c){ c.classList.remove('yg-is-active'); setDots(c); });
      if (!wasActive && preview){ preview.classList.add('is-active'); hotspot.classList.add('yg-is-active'); card.classList.add('yg-is-active'); setDots(card); }
      e.stopPropagation();
    }
    document.addEventListener('click', onHotspot);

    document.addEventListener('click', function(e){
      if (e.target.closest('.yg-hotspot, .yg-hotspot__preview, .yg-pcard__btn')) return;
      [root, lb].forEach(function(scope){ if(!scope) return; scope.querySelectorAll('.yg-hotspot__preview.is-active').forEach(function(p){ p.classList.remove('is-active'); }); scope.querySelectorAll('.yg-is-active').forEach(function(c){ c.classList.remove('yg-is-active'); if (c.classList.contains('yg-card')) setDots(c); }); });
    });

    var dtrack = root.querySelector('.yg-shoppable__track');
    var justDragged = false;
    if (dtrack){
      var down=false, moved=false, sx=0, sl=0, pid=null, TH=6;
      dtrack.addEventListener('pointerdown', function(e){ if (e.button!==0) return; down=true; moved=false; sx=e.clientX; sl=dtrack.scrollLeft; pid=e.pointerId; });
      dtrack.addEventListener('pointermove', function(e){ if (!down) return; var dx=e.clientX-sx; if (!moved && Math.abs(dx)>TH){ moved=true; dtrack.classList.add('yg-dragging'); try{dtrack.setPointerCapture(pid);}catch(_){} } if (moved) dtrack.scrollLeft = sl - dx; });
      function end(){ if (moved){ justDragged=true; setTimeout(function(){ justDragged=false; }, 50); } down=false; moved=false; dtrack.classList.remove('yg-dragging'); try{dtrack.releasePointerCapture(pid);}catch(_){} }
      dtrack.addEventListener('pointerup', end);
      dtrack.addEventListener('pointercancel', end);
      dtrack.addEventListener('click', function(e){ if (justDragged){ e.preventDefault(); e.stopPropagation(); } }, true);
    }

    var lbEnabled = root.getAttribute('data-lightbox') !== 'false';
    if (lbEnabled){
      lb = document.createElement('div');
      var ratioMod = (root.className.match(/yg-shoppable--ratio-[a-z]+/) || [''])[0];
      lb.className = 'yg-lightbox yg-shoppable ' + ratioMod;
      var ratioVal = (getComputedStyle(root).getPropertyValue('--yg-ratio') || '').trim();
      if (ratioVal) lb.style.setProperty('--yg-ratio', ratioVal);
      lb.innerHTML = '<button class="yg-lightbox__close" type="button" aria-label="Close">×</button><div class="yg-lightbox__stage"></div>';
      document.body.appendChild(lb);
      var stage = lb.querySelector('.yg-lightbox__stage');
      var closeBtn = lb.querySelector('.yg-lightbox__close');
      var openCard = null, placeholder = null;
      function playLBVideo(card){ var v=card.querySelector('video'); if(!v) return; v.muted=false; var mb=card.querySelector('.yg-card__mute'); if(mb){ mb.classList.add('is-unmuted'); mb.setAttribute('aria-pressed','false'); } try{ var p=v.play(); if(p&&p.catch)p.catch(function(){}); }catch(_){} }
      function openLB(card){
        if (openCard || !card) return;
        openCard = card;
        placeholder = document.createComment('yg-lb');
        card.parentNode.insertBefore(placeholder, card);
        stage.appendChild(card);
        lb.classList.add('is-open');
        document.body.classList.add('yg-lb-lock');
        playLBVideo(card);
        setTimeout(function(){ if(openCard===card) playLBVideo(card); }, 120);
      }
      function closeLB(){
        if (!openCard) return;
        var cv = openCard.querySelector('video'); if(cv){ cv.muted=true; var cmb=openCard.querySelector('.yg-card__mute'); if(cmb){ cmb.classList.remove('is-unmuted'); cmb.setAttribute('aria-pressed','true'); } }
        openCard.querySelectorAll('.yg-hotspot__preview.is-active').forEach(function(p){ p.classList.remove('is-active'); });
        openCard.querySelectorAll('.yg-hotspot.yg-is-active').forEach(function(h){ h.classList.remove('yg-is-active'); });
        openCard.classList.remove('yg-is-active');
        placeholder.parentNode.insertBefore(openCard, placeholder);
        placeholder.parentNode.removeChild(placeholder);
        lb.classList.remove('is-open');
        document.body.classList.remove('yg-lb-lock');
        setDots(openCard);
        openCard = null; placeholder = null;
      }
      closeLightbox = closeLB;
      closeBtn.addEventListener('click', function(e){ e.stopPropagation(); closeLB(); });
      lb.addEventListener('click', function(e){ if (e.target === lb) closeLB(); });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape' || e.keyCode === 27) closeLB(); });
      root.addEventListener('click', function(e){
        if (openCard) return;
        if (justDragged) return;
        if (e.target.closest('.yg-pcard__btn, .yg-hotspot, .yg-hotspot__dot, .yg-card__playpause, .yg-card__mute, .yg-shoppable__arrow')) return;
        var media = e.target.closest('.yg-card__media');
        if (!media) return;
        openLB(media.closest('.yg-card'));
      });
      stage.addEventListener('click', function(e){
        if (e.target.closest('.yg-hotspot, .yg-hotspot__dot, .yg-card__playpause, .yg-card__mute, .yg-pcard__btn, .yg-hotspot__preview')) return;
        var v = e.target.closest('video');
        if (v){ v.paused ? (v.play()||0) : v.pause(); }
      });
    }

    function onAdd(e){
      var btn = e.target.closest('.yg-pcard__btn'); if (!btn) return;
      var card = btn.closest('.yg-card'); if (!owns(card)) return;
      var id = btn.getAttribute('data-product-id'); if (!id) return;
      e.preventDefault(); e.stopPropagation();
      if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
      var original = btn.textContent;
      btn.classList.add('is-loading');
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items:[{ id:Number(id), quantity:1 }] }) })
        .then(function(r){ return r.json().then(function(d){ return { ok:r.ok, data:d }; }); })
        .then(function(res){
          btn.classList.remove('is-loading');
          if (!res.ok){
            btn.textContent = 'Unavailable';
            document.dispatchEvent(new CustomEvent('cart:error', { detail:{ errorMessage: res.data && res.data.description } }));
            setTimeout(function(){ btn.textContent = original; }, 1800);
            return;
          }
          btn.classList.add('is-added'); btn.textContent = 'Added';
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail:{ product: res.data } }));
          fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
            .then(function(r){ return r.json(); })
            .then(function(cart){ ygCartCount(cart.item_count); document.dispatchEvent(new CustomEvent('cart:updated', { detail:{ cart: cart } })); })
            .catch(function(){})
            .then(function(){
              closeLightbox();
              ygToast('Added to bag');
              setTimeout(function(){ btn.classList.remove('is-added'); btn.textContent = original; }, 1600);
            });
        })
        .catch(function(){ btn.classList.remove('is-loading'); btn.textContent = 'Try again'; setTimeout(function(){ btn.textContent = original; }, 1800); });
    }
    document.addEventListener('click', onAdd);
  });
})();
